'use client'

import React, { useEffect, useState } from 'react'
import { BlogSliderProps } from './types'
import { moveToAnchor } from '../../../utils/moveToAnchor'
import classNames from 'classnames'

const BlogSidebar = ({ items }: BlogSliderProps) => {
    const [activeAnchorIndex, setActiveAnchorIndex] = useState(0)
    function calculateVisibilityForDiv(div: HTMLDivElement, secondDiv?: HTMLDivElement | null) {
        const nextDiv =
                secondDiv !== null
                    ? secondDiv
                    : typeof document !== 'undefined'
                    ? document.getElementById('socialPopover')
                    : null,
            windowHeight = window.innerHeight,
            docScroll = window.scrollY,
            divPosition = div.offsetTop,
            nextDivPosition = nextDiv?.offsetTop || 0,
            sectionHeight = nextDivPosition - divPosition,
            hiddenBefore = docScroll - divPosition,
            hiddenAfter = divPosition + sectionHeight - (docScroll + windowHeight)
        if (docScroll > divPosition + sectionHeight || divPosition > docScroll + windowHeight) {
            return 0
        }
        let result = 100

        if (hiddenBefore > 0) {
            result -= (hiddenBefore * 100) / sectionHeight
        }

        if (hiddenAfter > 0) {
            result -= (hiddenAfter * 100) / sectionHeight
        }

        return result
    }

    const handleScroll = () => {
        const mostVisibleAnchor = items.reduce(
            (prev, curr, index) => {
                const elem =
                    typeof document !== 'undefined'
                        ? (document.getElementById(curr.replaceAll(' ', '-').toLowerCase()) as HTMLDivElement)
                        : null
                if (elem) {
                    if (index === items.length - 1) {
                        const visibility = calculateVisibilityForDiv(elem, null)
                        if (visibility > prev.visibility) {
                            return {
                                index,
                                visibility,
                            }
                        }
                        return prev
                    }

                    const nextElem =
                        typeof document !== 'undefined'
                            ? (document.getElementById(
                                  items[index + 1].replaceAll(' ', '-').toLowerCase()
                              ) as HTMLDivElement)
                            : null
                    if (nextElem) {
                        const visibility = calculateVisibilityForDiv(elem, nextElem)

                        if (visibility > prev.visibility) {
                            return {
                                index,
                                visibility,
                            }
                        }
                    }
                }
                return prev
            },
            { visibility: 0, index: 0 }
        )
        setActiveAnchorIndex(mostVisibleAnchor.index)
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    return (
        <div className="hidden lg:block sticky top-[90px] max-w-[80%] w-[400px] ml-auto bg-white rounded-[10px] shadow-[0px_5px_50px_0px_rgba(0,_0,_0,_0.10)]">
            <div className="border-b-[1px] border-black/10 text-[20px] leading-[20px] font-bold p-5">
                In dit artikel
            </div>
            <div className="p-5">
                <ul className="flex flex-col gap-5">
                    {items.map((item, index) => {
                        const element =
                            typeof document !== 'undefined'
                                ? document.getElementById(item.replaceAll(' ', '-').toLowerCase())
                                : null
                        return (
                            <li
                                className="cursor-pointer items-center flex gap-5"
                                key={item}
                                onClick={() => {
                                    if (element) {
                                        moveToAnchor(element, true)
                                    }
                                }}
                            >
                                <div
                                    className={classNames(
                                        `flex-shrink-0 rounded-full w-[14px] h-[14px]`,
                                        { 'bg-green-brand': index === activeAnchorIndex },
                                        { 'bg-grey': index !== activeAnchorIndex }
                                    )}
                                />
                                <span
                                    className={classNames(
                                        `hover:text-black`,
                                        { 'text-black': index === activeAnchorIndex },
                                        { 'text-grey': index !== activeAnchorIndex }
                                    )}
                                >
                                    {item}
                                </span>
                            </li>
                        )
                    })}
                </ul>
            </div>
        </div>
    )
}

export default BlogSidebar
